import { render, staticRenderFns } from "./EnslavedTimeStudy.vue?vue&type=template&id=2f83ad0a&scoped=true"
import script from "./EnslavedTimeStudy.vue?vue&type=script&lang=js"
export * from "./EnslavedTimeStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f83ad0a",
  null
  
)

export default component.exports